module.exports = __webpack_public_path__ + "img/comprehensiveImg2.7bb2b750.png";